<hawk-record-navigation
  [breadcrumbLinkList]="[{ link: '/a/lager/uebersicht', description: 'Lager' }]"
  [root]="'warehouse'"
  [leafDescription]="'Erwartete Lieferungen'"
  class="app-page"
>
  <div slot="toolbar" class="flex flex-row gap-2 items-center">
    <a routerLink="/lager/erwartete-lieferungen/neu" class="bm-btn bm-btn-primary">
      <i class="fa fa-plus"></i>
      Neue Lieferung erfassen
    </a>
    <input
      #quickFilterInput
      type="text"
      class="bm-input"
      placeholder="Schnellfilter..."
      (input)="quickSearchChanged($event)"
    />
  </div>
  <div class="page-content px-4 pb-2 flex flex-col gap-4 overflow-hidden">
    <!-- Assignment Mode Banner -->
    @if (assignmentMode && selectedQuickCaptured) {
      <div class="bm-alert bm-alert-info shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="stroke-current shrink-0 w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <div>
          <span class="font-semibold">Zuordnungs-Modus:</span>
          Wählen Sie eine Lieferung aus der Tabelle, um die Schnellerfassung
          <strong>#{{ selectedQuickCaptured.id }}</strong>
          @if (selectedQuickCaptured.supplier_name) {
            <span>({{ selectedQuickCaptured.supplier_name }})</span>
          }
          zuzuordnen.
        </div>
        <button class="bm-btn bm-btn-sm bm-btn-error" (click)="cancelAssignment()">Abbrechen</button>
      </div>
    }

    <!-- Erwartete Lieferungen -->
    <div class="flex-1 min-h-0 flex flex-col">
      <h2 class="text-lg font-semibold mb-2">Erwartete Lieferungen</h2>
      <div class="flex-1 min-h-0">
        <ag-grid-angular
          class="ag-theme-quartz h-full"
          [rowData]="expectedDeliveries"
          [theme]="hawkTheme"
          [defaultColDef]="defaultColDef"
          [columnDefs]="colDefs"
          [getRowStyle]="getRowStyle"
          [pagination]="true"
          [rowSelection]="rowSelection"
          [autoSizeStrategy]="autoSizeStrategy"
          [paginationPageSize]="50"
          [localeText]="locale"
          [sideBar]="sideBarOptions"
          [paginationPageSizeSelector]="[25, 50, 100, 250]"
          [suppressHorizontalScroll]="true"
          (gridReady)="onGridReady($event)"
        />
      </div>
    </div>

    <!-- Schnellerfassungen (wenn vorhanden) -->
    @if (unassignedQuickCapturedCount > 0) {
      <div class="shrink-0">
        <div class="flex items-center gap-2 mb-2">
          <h2 class="text-lg font-semibold">Aktuelle Schnellerfassungen vom Lager</h2>
          <span class="badge badge-warning">{{ unassignedQuickCapturedCount }} nicht zugeordnet</span>
        </div>
        <div class="h-48 border border-base-300 rounded-lg overflow-hidden">
          <ag-grid-angular
            class="ag-theme-quartz h-full w-full"
            [rowData]="quickCapturedDeliveries"
            [theme]="hawkTheme"
            [defaultColDef]="defaultColDef"
            [columnDefs]="quickCapturedColDefs"
            [rowSelection]="rowSelection"
            [autoSizeStrategy]="autoSizeStrategy"
            [localeText]="locale"
            [suppressPaginationPanel]="true"
            [suppressHorizontalScroll]="true"
            (gridReady)="onQuickCapturedGridReady($event)"
          />
        </div>
      </div>
    }
  </div>
</hawk-record-navigation>

<!-- PDF Viewer Modal -->
@if (pdfViewerUrl) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50" (click)="closePdfViewer()">
    <div
      class="bg-base-100 rounded-lg shadow-xl w-[95vw] h-[90vh] max-w-6xl flex flex-col"
      (click)="$event.stopPropagation()"
    >
      <!-- Modal Header -->
      <div class="flex items-center justify-between p-4 border-b border-base-300">
        <h3 class="text-lg font-semibold">{{ pdfViewerTitle }}</h3>
        <button
          class="bm-btn bm-btn-ghost bm-btn-square"
          (click)="closePdfViewer()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <!-- PDF Content -->
      <div class="flex-1 overflow-hidden">
        <iframe
          [src]="pdfViewerUrl"
          class="w-full h-full border-0"
          title="PDF Vorschau"
        ></iframe>
      </div>
    </div>
  </div>
}
